enum GuestMobileOrderingMode {
  dineIn = 1,
  toGo,
  dineInToGo
}

export default GuestMobileOrderingMode
